import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    height: "42px",
  },
  addText: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
  },
}));